<template>
  <div :id="'ac-'+aindex" class="answer-card" style="opacity: 0;"
  @click="giveAnswer">

    <h3 class="title" v-if="answer.type == 'string'" v-html="answer.content"></h3>

    <img v-else :src="answer.content" :alt="answer.alt">
  </div>
</template>

<script>
  export default {
    mounted() {
      const self = this;
      anime({
        targets: self.$el,
        opacity: 1,
        translateY: 0,
        duration: 1000,
        delay: 100,
        easing: 'easeOutExpo'
      })
    },
    props: {
      answer: {
        type: Object,
        required: true
      },
      aindex: {
        type: Number,
        required: true
      }
    },
    methods: {
      giveAnswer() {
        this.$emit("answer", this.aindex);
      }
    },
  }
</script>

<style lang="scss">

  .answer-card {

    border-radius: 5px;
    position: relative;
    width: 47%;
    min-width: 145px;
    opacity: 0;
    border: 2px solid $color-primary;
    margin: 1.50px;
    //max-height: 270px;

    // @media all and (min-width: 960px) {
    //   //max-height: 200px;
    //   max-width: 180px;
    //   max-height: 270px;
    // }
    // @include media-query($small-up) {
    //   max-height: 424px;
    // }

    @include media-query($medium-up) {
      width: 16%;
      max-width: 180px;
      max-height: 200px;
    }

    // img{
    //   max-width: 100%;
    //   height: auto;
    // }


    &:before{
      content: "";
      width: 100%;
      display: block;
      //padding-bottom: 120.65625%;
    }

    .length6 &:before{
      //padding-bottom: 76.375%;
    }

     .ipad-frame &{
      width: 16%;
     }

      .ipad-frame  &:before {
        //padding-bottom: 125%;
      }


    > * {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      margin: 0;
    }

    &:nth-child(6n + 1) {
      background-color: #f69783;
    }
    &:nth-child(6n + 2) {
      background-color: #91cbb7;
    }
    &:nth-child(6n + 3) {
      background-color: #2baade;
    }
    &:nth-child(6n + 4) {
      background-color: #fbb161;
    }
    &:nth-child(6n + 5) {
      background-color: #f7ba9b;
    }
    &:nth-child(6n) {
      background-color: #b20e3a;
    }


    .title {
      font-size: 1.25em;
      font-family: $sans-serif;
      font-weight: 400;
      color: white;
      display: block;
    }

    .icon {
      top: 10px;
      right: 10px;

      width: 2.5em;
      height: 2.5em;

      display: block;
      position: absolute;

      background-color: #fff;

      border-radius: 50%;

      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        height: 60%;
        width: 60%;
        fill: $color-primary;
      }
    }
    img {
      // height: 60%;
      // width: auto;
      width: 75%;
      height: auto;
    }
  }


</style>